import styled from 'styled-components';
import Text from './common/Text';

export const HeadLine = styled(Text)`
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.41px;
  line-height: 22px;
`;

export const FooterNote = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.08px;
  line-height: 23px;
`;

export const BodyText = styled(Text)`
  font-size: 17px;
  font-weight: normal;
  letter-spacing: -0.41px;
  line-height: 22px;
`;

export const Caption1 = styled(Text)`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 16px;
`;

export const Caption2 = styled(Text)`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06px;
  line-height: 13px;
`;

export const TableHeading = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.24px;
  line-height: 20px;
`;
